<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card class="mt-2">
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('BasketDetails')">
            <basket-details></basket-details>
          </vs-tab>
          <vs-tab :label="$t('FilesAndAttachments')">
            <files-and-attachments></files-and-attachments>
          </vs-tab>
          <vs-tab :label="$t('Events')">
            <events></events>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import BasketDetails from "./BasketDetails.vue";
import Events from "./Events.vue";
import FilesAndAttachments from "./FilesAndAttachments.vue";
export default {
  name:"basketManagement_ChannelBaskets_Details",
  components: {
    BasketDetails,
    Events,
    FilesAndAttachments,
  },
};
</script>
